/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DutyScheduleDisplayStatus } from './DutyScheduleDisplayStatus';
import {
    DutyScheduleDisplayStatusFromJSON,
    DutyScheduleDisplayStatusFromJSONTyped,
    DutyScheduleDisplayStatusToJSON,
    DutyScheduleDisplayStatusToJSONTyped,
} from './DutyScheduleDisplayStatus';
import type { DutyScheduleCounselorSnapshotResponse } from './DutyScheduleCounselorSnapshotResponse';
import {
    DutyScheduleCounselorSnapshotResponseFromJSON,
    DutyScheduleCounselorSnapshotResponseFromJSONTyped,
    DutyScheduleCounselorSnapshotResponseToJSON,
    DutyScheduleCounselorSnapshotResponseToJSONTyped,
} from './DutyScheduleCounselorSnapshotResponse';
import type { DutyScheduleColumnResponse } from './DutyScheduleColumnResponse';
import {
    DutyScheduleColumnResponseFromJSON,
    DutyScheduleColumnResponseFromJSONTyped,
    DutyScheduleColumnResponseToJSON,
    DutyScheduleColumnResponseToJSONTyped,
} from './DutyScheduleColumnResponse';
import type { DutyScheduleSlotResponse } from './DutyScheduleSlotResponse';
import {
    DutyScheduleSlotResponseFromJSON,
    DutyScheduleSlotResponseFromJSONTyped,
    DutyScheduleSlotResponseToJSON,
    DutyScheduleSlotResponseToJSONTyped,
} from './DutyScheduleSlotResponse';

/**
 * 
 * @export
 * @interface DutyScheduleDetailResponse
 */
export interface DutyScheduleDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleDetailResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleDetailResponse
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleDetailResponse
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleDetailResponse
     */
    periodEnd: Date;
    /**
     * 
     * @type {DutyScheduleDisplayStatus}
     * @memberof DutyScheduleDetailResponse
     */
    status: DutyScheduleDisplayStatus;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDetailResponse
     */
    workingDays: number | null;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDetailResponse
     */
    dutyCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDetailResponse
     */
    unfilledSlots: number | null;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDetailResponse
     */
    counselorCount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleDetailResponse
     */
    calculatedAtUtc: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleDetailResponse
     */
    lastModifiedAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleDetailResponse
     */
    lastModifiedByUserCode: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleDetailResponse
     */
    lastModifiedByName: string | null;
    /**
     * 
     * @type {Array<DutyScheduleColumnResponse>}
     * @memberof DutyScheduleDetailResponse
     */
    columns: Array<DutyScheduleColumnResponse>;
    /**
     * 
     * @type {Array<Date>}
     * @memberof DutyScheduleDetailResponse
     */
    workingDayDates: Array<Date>;
    /**
     * 
     * @type {Array<DutyScheduleSlotResponse>}
     * @memberof DutyScheduleDetailResponse
     */
    slots: Array<DutyScheduleSlotResponse>;
    /**
     * 
     * @type {Array<DutyScheduleCounselorSnapshotResponse>}
     * @memberof DutyScheduleDetailResponse
     */
    counselorSnapshots: Array<DutyScheduleCounselorSnapshotResponse>;
}



/**
 * Check if a given object implements the DutyScheduleDetailResponse interface.
 */
export function instanceOfDutyScheduleDetailResponse(value: object): value is DutyScheduleDetailResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('periodStart' in value) || value['periodStart'] === undefined) return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('workingDays' in value) || value['workingDays'] === undefined) return false;
    if (!('dutyCount' in value) || value['dutyCount'] === undefined) return false;
    if (!('unfilledSlots' in value) || value['unfilledSlots'] === undefined) return false;
    if (!('counselorCount' in value) || value['counselorCount'] === undefined) return false;
    if (!('calculatedAtUtc' in value) || value['calculatedAtUtc'] === undefined) return false;
    if (!('lastModifiedAtUtc' in value) || value['lastModifiedAtUtc'] === undefined) return false;
    if (!('lastModifiedByUserCode' in value) || value['lastModifiedByUserCode'] === undefined) return false;
    if (!('lastModifiedByName' in value) || value['lastModifiedByName'] === undefined) return false;
    if (!('columns' in value) || value['columns'] === undefined) return false;
    if (!('workingDayDates' in value) || value['workingDayDates'] === undefined) return false;
    if (!('slots' in value) || value['slots'] === undefined) return false;
    if (!('counselorSnapshots' in value) || value['counselorSnapshots'] === undefined) return false;
    return true;
}

export function DutyScheduleDetailResponseFromJSON(json: any): DutyScheduleDetailResponse {
    return DutyScheduleDetailResponseFromJSONTyped(json, false);
}

export function DutyScheduleDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'periodStart': (new Date(json['periodStart'])),
        'periodEnd': (new Date(json['periodEnd'])),
        'status': DutyScheduleDisplayStatusFromJSON(json['status']),
        'workingDays': json['workingDays'],
        'dutyCount': json['dutyCount'],
        'unfilledSlots': json['unfilledSlots'],
        'counselorCount': json['counselorCount'],
        'calculatedAtUtc': (json['calculatedAtUtc'] == null ? null : new Date(json['calculatedAtUtc'])),
        'lastModifiedAtUtc': (new Date(json['lastModifiedAtUtc'])),
        'lastModifiedByUserCode': json['lastModifiedByUserCode'],
        'lastModifiedByName': json['lastModifiedByName'],
        'columns': ((json['columns'] as Array<any>).map(DutyScheduleColumnResponseFromJSON)),
        'workingDayDates': (json['workingDayDates'] as Array<any>).map((el: any) => new Date(el)),
        'slots': ((json['slots'] as Array<any>).map(DutyScheduleSlotResponseFromJSON)),
        'counselorSnapshots': ((json['counselorSnapshots'] as Array<any>).map(DutyScheduleCounselorSnapshotResponseFromJSON)),
    };
}

export function DutyScheduleDetailResponseToJSON(json: any): DutyScheduleDetailResponse {
    return DutyScheduleDetailResponseToJSONTyped(json, false);
}

export function DutyScheduleDetailResponseToJSONTyped(value?: DutyScheduleDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'periodStart': `${value['periodStart'].getFullYear()}-${String(value['periodStart'].getMonth()+1).padStart(2,'0')}-${String(value['periodStart'].getDate()).padStart(2,'0')}`,
        'periodEnd': `${value['periodEnd'].getFullYear()}-${String(value['periodEnd'].getMonth()+1).padStart(2,'0')}-${String(value['periodEnd'].getDate()).padStart(2,'0')}`,
        'status': DutyScheduleDisplayStatusToJSON(value['status']),
        'workingDays': value['workingDays'],
        'dutyCount': value['dutyCount'],
        'unfilledSlots': value['unfilledSlots'],
        'counselorCount': value['counselorCount'],
        'calculatedAtUtc': value['calculatedAtUtc'] == null ? value['calculatedAtUtc'] : value['calculatedAtUtc'].toISOString(),
        'lastModifiedAtUtc': value['lastModifiedAtUtc'].toISOString(),
        'lastModifiedByUserCode': value['lastModifiedByUserCode'],
        'lastModifiedByName': value['lastModifiedByName'],
        'columns': ((value['columns'] as Array<any>).map(DutyScheduleColumnResponseToJSON)),
        'workingDayDates': (value['workingDayDates'] as Array<Date>).map((el) => `${el.getFullYear()}-${String(el.getMonth()+1).padStart(2,'0')}-${String(el.getDate()).padStart(2,'0')}`),
        'slots': ((value['slots'] as Array<any>).map(DutyScheduleSlotResponseToJSON)),
        'counselorSnapshots': ((value['counselorSnapshots'] as Array<any>).map(DutyScheduleCounselorSnapshotResponseToJSON)),
    };
}

